import React from 'react'
import { WithWizard } from 'react-albus'
import { isMobile, isTablet, isBrowser } from 'react-device-detect'
import PropTypes from 'prop-types'

import * as routes from 'core/routing/constants/index'
import styled from 'styled-components'
import { injectIntl } from 'react-intl'
import { ButtonPrev, ButtonNext, Row, Col, Card, Steps } from 'core/components/ui'
import Hydrator, { hydratorMethods } from 'core/hydrator'
import { greys } from 'assets/themes/theme-default'
import wizardsShape from '../wizard/shapes'
import { configuratorShape } from '../../../configurator/shapes'
import { stockShape } from '../../../stock/shapes'
import { tradeInShape } from '../../../trade-in/shapes'

//import PreviewVehicle, { TYPE } from './preview-vehicle'

const StyledCard = styled(Card)`
  &&& {
    background: ${greys.light4};
    margin: ${isMobile || isTablet ? '0' : '15px 0 0 0'};
  }
`

const { Step } = Steps

const NavigationWrapper = styled.div`
  position: fixed;
  z-index: 6;
  bottom: 0;
  right: 0;
  left: 0;
  max-width: 100vw;
  padding: ${isMobile || isTablet ? '10px 0 15px 0' : '20px 0 15px 0'};
  height: ${(isMobile || isTablet) && '70px'};
  overflow: hidden;
  background: ${props =>
    props.background || (isMobile || isTablet ? props.theme.colors.color2.bg : greys.light4)};
  border-top: ${props =>
    props.border ? `1px solid ${props.border}` : isBrowser && `1px solid ${greys.dark3}`};
`
const StepsWrapper = styled.div`
  max-width: ${isMobile || isTablet ? '600px' : '800px'};
  margin: 0 auto 20px auto;
  padding: ${isMobile || isTablet ? '0' : '0 30px'};
  .ant-card-body {
    padding: ${(isMobile || isTablet) && '12px'};
    display: flex;
    justify-content: center;
  }

  .ant-steps-item-tail {
    margin-left: ${(isMobile || isTablet) && '12px !important'};
  }

  .ant-steps-item-icon {
    margin: ${(isMobile || isTablet) && '0px'};
    margin-left: ${(isMobile || isTablet) && '0px !important'};
  }
  .ant-steps-item-content {
    display: ${(isMobile || isTablet) && 'none'};
    .ant-steps-item-title,
    .ant-steps-item-description {
      display: ${(isMobile || isTablet) && 'none'};
    }
  }

  &&& .ant-card {
    background: ${(isMobile || isTablet) && '0 none'};
  }
`

const StyledStep = styled(Step)`
  .ant-steps-item-tail {
    :after {
      ${props =>
        props.progress &&
        `background-image: linear-gradient(
        to right,
        ${props.theme.colors.color1.bg} ${props.progress}%,
        ${greys.dark3} ${props.progress}%
      );`}
    }
  }
  .ant-steps-item-icon {
    margin-top: 11px;
  }
  .ant-steps-item-content {
    position: relative;
    top: -57px;
  }
`

const Navigation = props => {
  /*const togglePreview = () => {
    const { onTogglePreview } = props
    onTogglePreview()
  }*/

  const {
    wizards,
    configurator,
    stock,
    tradeIn,
    setLayoutTradeInPreview,
    setLayoutVehiclePreview,
    setLayoutModalInfo,
    intl,
    //layoutTradeIn,
    configuration
  } = props

  const { campaign } = configuration

  let vehicleTradeIn = null
  if (tradeIn.vehicle) vehicleTradeIn = tradeIn.vehicle

  return (
    <WithWizard
      render={({ push, next, step, steps }) => {
        const stepsActive = wizards[wizards.activeWizard]

        // Index of current step
        const currentStepIndex = steps.indexOf(step)

        // Calculate percent for progress bar
        const currentIndex = currentStepIndex + 1
        const percent = (currentIndex * 100) / steps.length

        // Bool to show or not the button next
        let nextStepIsActive = false

        if (currentStepIndex > -1 && currentStepIndex < steps.length - 1) {
          nextStepIsActive = stepsActive.filter(
            stepItem => stepItem.hash === steps[currentStepIndex + 1].id
          )[0].isActive
        }

        const { backButtonText, nextButtonText } = step

        // Label of the previous step for the back button

        let prevStepId
        if (currentStepIndex > 0) {
          const prevStep = steps[currentStepIndex - 1]

          prevStepId = prevStep.id
        }

        let stepIndexNumber = -1

        const renderSteps = steps.map((item, index) => {
          const stepCurrent = stepsActive.filter(stepItem => stepItem.hash === item.id)[0]
          const distributorStepIndex = steps.findIndex(x => x.id === routes.TRADEIN_DISTRIBUTOR)

          const stepActive = stepCurrent.isActive
          const stepPrincipal = stepCurrent.isStepPrincipal
          let stepClickable = !vehicleTradeIn || (vehicleTradeIn && percent !== 100)
          if (
            stepActive &&
            index < distributorStepIndex &&
            currentStepIndex >= distributorStepIndex
          ) {
            stepClickable = false
          }

          if (!stepPrincipal) return false
          if (stepActive && index <= currentStepIndex) stepIndexNumber += 1

          const endIndex = stepsActive.findIndex((x, i) => x.isStepPrincipal && i > index)
          const dividedItem = stepsActive.slice(
            index + 1,
            endIndex !== -1 ? endIndex + 1 : stepsActive.length
          )

          const percentItem =
            (dividedItem.slice(0, dividedItem.findIndex(x => x.hash === step.id) + 1).length /
              dividedItem.length) *
            100

          const onClickHandler = () => {
            const hash = item.id

            if (stepActive && stepClickable) {
              // Modal delete current tradeIn config
              if (
                vehicleTradeIn &&
                (hash === routes.TRADEIN_VEHICLE ||
                  hash === routes.CONFIGURATOR_TRADEIN ||
                  hash === routes.STOCK_TRADEIN)
              ) {
                const modalInfos = {
                  showModal: true,
                  title: intl.formatMessage({ id: 'configurator-modal-delete-tradein-title' }),
                  content: intl.formatMessage({
                    id: 'configurator-modal-delete-tradein-content'
                  }),
                  route: hash
                }

                setLayoutModalInfo(modalInfos)
              } /*else if (configurator.brand && hash === routes.CONFIGURATOR_BRANDS) {
                  // Modal delete current configurator config
                  const modalInfos = {
                    showModal: true,
                    title: intl.formatMessage({
                      id: 'configurator-modal-delete-configurator-title'
                    }),
                    content: intl.formatMessage({
                      id: 'configurator-modal-delete-configurator-content'
                    }),
                    route: hash
                  }

                  setLayoutModalInfo(modalInfos)
                } */ else {
                push(hash)
              }
            }
          }

          return (
            <StyledStep
              key={item.id}
              title={item.title}
              description={item.subTitle}
              onClick={onClickHandler}
              style={{ cursor: stepActive && stepClickable ? 'pointer' : 'default' }}
              progress={Number.isNaN(percentItem) || percentItem === 100 ? 0 : percentItem}
            />
          )
        })

        if (wizards.activeWizard === 'aStepsConfigurator') {
          const aStepsActive = wizards[wizards.activeWizard]
          const indexToCheck =
            aStepsActive.findIndex(stepItem => stepItem.hash === routes.CONFIGURATOR_MODELS) + 1

          if (configurator && currentIndex > indexToCheck && currentIndex < steps.length) {
            const vehicle = Hydrator.hydrate(
              hydratorMethods.HYDRATE_VEHICULE_FROM_CONFIGUARTOR,
              configurator
            )

            setLayoutVehiclePreview(vehicle)
          }
        }

        if (wizards.activeWizard === 'aStepsStock') {
          const aStepsActive = wizards[wizards.activeWizard]
          const indexToCheck = aStepsActive.findIndex(
            stepItem => stepItem.hash === routes.STOCK_CONGRATULATIONS
          )

          if (stock && currentIndex > indexToCheck && currentIndex < steps.length) {
            const { selectedVehicle, funding } = stock

            const vehicle = {
              ...selectedVehicle,
              funding,
              prices: null
            }

            setLayoutVehiclePreview(vehicle)
          }
        }

        if (wizards.activeWizard === 'aStepsTradeIn') {
          const aStepsActive = wizards[wizards.activeWizard]
          const indexToCheck =
            aStepsActive.findIndex(stepItem => stepItem.hash === routes.TRADEIN_VEHICLE_CONFIRM) + 1

          if (tradeIn && currentIndex > indexToCheck && currentIndex < steps.length) {
            setLayoutTradeInPreview(vehicleTradeIn)
          }
        }

        return (
          <>
            {(backButtonText || nextButtonText) && (
              <NavigationWrapper
                background={
                  campaign &&
                  campaign.theme &&
                  campaign.theme.header &&
                  campaign.theme.header.footer &&
                  campaign.theme.header.footer.background
                }
                border={
                  campaign &&
                  campaign.theme &&
                  campaign.theme.header &&
                  campaign.theme.header.footer &&
                  campaign.theme.header.footer.border
                }
              >
                <Row type="flex" justify="space-around" align="middle" style={{ height: '100%' }}>
                  <Col span={isMobile || isTablet ? 12 : 4} style={{ textAlign: 'center' }}>
                    {steps.indexOf(step) > 0 && backButtonText && (
                      <ButtonPrev
                        onClick={() => {
                          push(prevStepId)
                          window.scrollTo(0, 0)
                        }}
                        style={{ height: '35px' }}
                      >
                        {backButtonText}
                      </ButtonPrev>
                    )}
                  </Col>
                  <Col span={isMobile || isTablet ? 12 : 4} style={{ textAlign: 'center' }}>
                    {steps.indexOf(step) < steps.length - 1 && nextButtonText && (
                      <ButtonNext
                        onClick={() => {
                          next()
                          window.scrollTo(0, 0)
                        }}
                        style={{ height: '35px' }}
                        disabled={!nextStepIsActive}
                      >
                        {nextButtonText}
                      </ButtonNext>
                    )}
                  </Col>
                </Row>
              </NavigationWrapper>
            )}

            <StepsWrapper>
              <StyledCard bordered={false}>
                <Steps
                  current={stepIndexNumber}
                  direction="horizontal"
                  responsive={false}
                  size="small"
                  labelPlacement="vertical"
                >
                  {renderSteps}
                </Steps>
                {/* {layoutTradeIn && <PreviewVehicle vehicle={layoutTradeIn} type={TYPE.UC} />} */}
              </StyledCard>
            </StepsWrapper>
          </>
        )
      }}
    />
  )
}

Navigation.propTypes = {
  wizards: wizardsShape.isRequired,
  configurator: configuratorShape.isRequired,
  stock: stockShape.isRequired,
  tradeIn: tradeInShape.isRequired,
  setLayoutVehiclePreview: PropTypes.func.isRequired,
  setLayoutTradeInPreview: PropTypes.func.isRequired,
  setLayoutModalInfo: PropTypes.func.isRequired,
  intl: PropTypes.shape().isRequired,
  //layoutTradeIn: PropTypes.shape().isRequired,
  configuration: PropTypes.shape().isRequired
}

export default injectIntl(Navigation)
